import React, { useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { NavgationPageLocationKey } from '../../../utils/constants';
import { Button, Card, CardBody, CardHeader, Col, Container, DatePicker, FormInput, FormSelect, InputGroup, InputGroupAddon, InputGroupText, Row } from 'shards-react';
import ReactTable from 'react-table';
import { useEffect } from 'react';
import { setDateForTable, setDateForTableInHrMinSec, setInputDate } from '../../../utils/date';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { get_pay_schedule_list, get_payroll_taximort_type } from '../../../redux/actions/subscriber/payroll';
import { get_import_log_status_list, get_import_logs_list } from '../../../redux/actions/subscriber/importLog';

const ImportLog = ({
    get_payroll_taximort_type, payrollTaxImportType,
    get_import_log_status_list, importStatusList,
    get_import_logs_list, importLogList,
    get_pay_schedule_list, payScheduleList
}) => {

    const initialState = {
        pageSizeOptions: [5, 10, 15, 20, 25, 30],
        pageSize: 10,
        from: '',
        to: '',
        refNum: '',
        status: '',
        importType: '',
        paySchedule: '',
    }
    
    const [state, setState] = useState({ ...initialState });
    const payrollTaxImportTypeOptions = (payrollTaxImportType || []).map(importType => <option key={importType} value={importType}>{importType}</option>)
    const payScheduleListOptions = (payScheduleList || []).map(paySchedule => <option key={paySchedule.payScheduleName + paySchedule.payScheduleRefNum} value={paySchedule.payScheduleRefNum}>{paySchedule.payScheduleName}</option>)
    const statusListOption = (importStatusList || []).map(status => <option key={status} value={status}>{status}</option>)
    const { pageSize, pageSizeOptions } = state;

    const [tableData, setTableData] = useState([]);
    const history = useHistory();

    const onChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };

    function navigateToImportLog(e, refId) {
        e.preventDefault();
        history.push({
            pathname: `/import-log-details`,
            state: { refNum: refId }
        });
        return false;
    }

    function onContextMenuImportLogChange(e, refId) {
        if (e.type === 'contextmenu') {
            localStorage.setItem(NavgationPageLocationKey.ImportLogAddEdit, refId);
        }
    }

    function openImportLogInNewTab(e, refId) {
        e.preventDefault();
        localStorage.setItem(NavgationPageLocationKey.ImportLogAddEdit, refId);
        window.open('/import-log-details', '_blank');
    }

    const tableColumns = [
        {
            Header: "Ref #",
            accessor: "refNum",
            //maxWidth: 100, 
            minWidth: 80,
            Cell: row => <>
                <a href="/import-log-details" onClick={(e) => { openImportLogInNewTab(e, row.original.refNum) }}
                    onContextMenu={(e) => onContextMenuImportLogChange(e, row.original.refNum)}>
                    {"IMP-"}{row.original.refNum}
                </a>
            </>
        },
        {
            Header: "Import Type",
            accessor: "importType",
            minWidth: 200, 
            //maxWidth: 220,
            classNames: 'text-center',
            Cell: row => <span className="w-100 text-left" title={row.original.importType}>{row.original.importType}</span>
        },
        {
            Header: "Pay Schedule",
            accessor: "paySchedule",
            minWidth: 140, 
            //maxWidth: 150,
            classNames: 'text-left',
            Cell: row => <span className="w-100 text-left" title={row.original.paySchedule}>{row.original.paySchedule}</span>
        },
        {
            Header: "Pay Period",
            accessor: "payPeriod",
            //maxWidth: 130, 
            minWidth: 120,
            Cell: row => <span className="w-100 text-left" title={row.original.payPeriod}>{row.original.payPeriod}</span>
        },
        {
            Header: "Start Date",
            accessor: "startDate",
            minWidth: 120,
            //maxWidth: 120,
            Cell: row => setDateForTable(row.original.startDate)
        },
        {
            Header: "Date Time Actioned",
            accessor: "dateTimeActioned",
            //maxWidth: 170, 
            minWidth: 170,
            Cell: row => setDateForTableInHrMinSec(row.original.dateTimeActioned)
        },
        {
            Header: "Status",
            accessor: "status",
            //maxWidth: 130, 
            minWidth: 130,
            Cell: row => <span className="w-100 text-left" title={row.original.status}>{row.original.status}</span>
        },
        {
            Header: "Action By",
            accessor: "actionBy",
            minWidth: 210,
            //maxWidth: 210,
            classNames: 'text-left',
            Cell: row => <span className="w-100 text-left" title={row.original.actionBy}>{row.original.actionBy}</span>
        },
    ]

    const reset = () => {
        setState({ ...initialState })
        get_import_logs_list("", "", "", "", "", "");
    }

    const onSearch = (e) => {
        e.preventDefault()
        let splitedRef = state.refNum.split('-');
        const refNum = splitedRef.length > 1 ? splitedRef[1] : state.refNum;
        get_import_logs_list(refNum, state.importType, state.paySchedule, state.status, setInputDate(state.from), setInputDate(state.to))
    }
    useEffect(() => {
        get_import_logs_list("", "", "", "", "", "");
        get_import_log_status_list();
        get_payroll_taximort_type();
        get_pay_schedule_list();
    }, [])

    useEffect(() => {
        setTableData([...importLogList])
    }, [importLogList])

    return (
        <Container fluid className="main-content-container px-4 pb-4">
            <div className="page-header tableSearch flex-column flex-md-row py-2 d-flex justify-content-end bg-white mt-4 ">

                <div className="d-flex align-items-center p-2">
                    <FormInput
                        name='refNum' value={state.refNum}
                        onChange={onChange} placeholder="Ref #"
                    />
                </div>

                <div className="d-flex align-items-center p-2">
                    <FormSelect
                        id="importType"
                        name="importType"
                        value={state.importType}
                        onChange={onChange}>
                        <option key={`status`} value=''>Import Type</option>
                        { payrollTaxImportTypeOptions }
                    </FormSelect>
                </div>

                <div className="d-flex align-items-center p-2">
                    <FormSelect
                        id="status"
                        name="status"
                        value={state.status}
                        onChange={onChange}>
                        <option key={`status`} value=''>Select Status</option>
                        { statusListOption }
                    </FormSelect>
                </div>
                <div className="d-flex align-items-center p-2">
                    <FormSelect
                        id="paySchedule"
                        name="paySchedule"
                        value={state.paySchedule}
                        onChange={onChange}>
                        <option key={`paySchedule`} value=''>Select Pay Schedule</option>
                        { payScheduleListOptions }
                    </FormSelect>
                </div>

                <div className="d-flex align-items-center p-2">
                    <div className="d-flex align-items-center p-2">
                        <InputGroup className={classNames("d-flex", "my-auto", "date-range")}>
                            <DatePicker
                                name="from"
                                size="sm"
                                selected={state.from}
                                onChange={(date) => {
                                    setState({ ...state, from: date })
                                }}
                                dateFormat='yyyy-MM-dd'
                                placeholderText="From"
                                dropdownMode="select"
                                autoComplete='off'
                                className="text-center"
                            />
                            <DatePicker
                                name="to"
                                size="sm"
                                selected={state.to}
                                onChange={(date) => {
                                    setState({ ...state, to: date })
                                }}
                                dateFormat='yyyy-MM-dd'
                                placeholderText="To"
                                dropdownMode="select"
                                autoComplete='off'
                                className="text-center"
                                popperPlacement="top-end"
                            />
                            <InputGroupAddon type="append">
                                <InputGroupText>
                                    <i className="material-icons">&#xE916;</i>
                                </InputGroupText>
                            </InputGroupAddon>
                        </InputGroup>
                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-end p-2">
                    <Button className="mx-2 py-2 my-2" size='sm' name="Search" theme="accent"
                        onClick={onSearch}>Search</Button>
                    <Button className="mx-2 py-2 my-2" size='sm' theme="accent" onClick={reset} >
                        Reset
                    </Button>
                </div>
            </div>

            <Card className="tableCard p-0">
                <CardHeader className="p-0">
                    <Container fluid className="file-manager__filters border-bottom">
                        <Row>
                            {/* Filters :: Page Size */}

                            <Col lg="2" className="file-manager__filters__rows d-flex justify-content-center justify-content-md-start align-items-center cl-2">
                            </Col>
                            <Col lg="3" className="d-flex align-items-center">
                            </Col>
                            <Col lg="6" className="file-manager__filters__search d-flex justify-content-md-start col-7">
                            </Col>

                            <Col lg="1"
                                className="file-manager__filters__rows d-flex justify-content-center justify-content-md-end align-items-center col-2">
                                <span>Show</span>
                                <FormSelect
                                    size="sm"
                                    name='pageSize'
                                    value={state.pageSize}
                                    onChange={onChange}
                                >
                                    {pageSizeOptions.map((size, idx) => (
                                        <option key={idx} value={size}>
                                            {size} rows
                                        </option>
                                    ))}
                                </FormSelect>
                            </Col>
                        </Row>
                    </Container>
                </CardHeader>
                <CardBody className="p-0">
                    <div className="">
                        <ReactTable
                            columns={tableColumns}
                            data={tableData}
                            pageSize={Number(pageSize)}
                            showPageSizeOptions={false}
                            resizable={false}
                            noDataText="No results found"
                            previousText={<i class='fa fa-chevron-left' aria-hidden='true'></i>}
                            nextText={<i class='fa fa-chevron-right' aria-hidden='true'></i>}
                        />
                    </div>
                </CardBody>
            </Card>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    payrollTaxImportType: state.payroll.payrollTaxImportType,
    importLogList: state.importLog.importLogList,
    importStatusList: state.importLog.importStatusList,
    payScheduleList: state.payroll.payScheduleList,
})

export default connect(mapStateToProps, {
    get_payroll_taximort_type,
    get_import_log_status_list,
    get_import_logs_list,
    get_pay_schedule_list,
})(ImportLog)
